import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import { Aside } from '../../components/Aside';
import Dash from '../../components/Dash';
import { GlobalStyle } from '../../styles/global';
import Modal from '../../components/Modal';
import { useLocation } from "react-router-dom";
import Loading from '../../components/Loading';


const Conjuge: React.FC = () => {

  const location = useLocation();
  const [showmodal, setShowmodal] = useState(false);
  const [datamodal] = useState({})
  const [updateCiclo, setUpdateciclo] = useState(false);  
  const [load, setLoad] = useState(true);

  
  useEffect(() => {
    let mounted = true;
    if(mounted){
      
      setLoad(false);
    }
    return function cleanup() {
        mounted = false
    }
  }, [location]);

  return (
    <>
    {!load ? (
    <>
        <Modal 
          show={showmodal} 
          setShowmodal={() => 
          setShowmodal(!showmodal)} 
          datamodal={datamodal} 
          setUpdateciclo={() => setUpdateciclo(!updateCiclo) } 
        />
        <Header />
        <Aside />
        <Dash aluno={location.state.conjuge} />
        <GlobalStyle />
    </>
    ) : (
      <Loading />
    )}
    </>
   );
}

export default Conjuge;